import {
    IGamingHistoryService
} from "./gaming-history.service.interfce";
import {ServiceBase} from "../ServiceBase";
import {IHistoryPaginatorViewModel} from "./models/paginator/history-paginator-view-model.interface";
import {UserGamingHistoryPaginatorModel} from "./models/paginator/user-gaming-history-paginator.model";
import {GamingHistoryType} from "./gaming-history-type";
import {SessionGamingHistoryPaginatorModel} from "./models/paginator/session-gaming-history-paginator.model";

export class GamingHistoryService extends ServiceBase implements IGamingHistoryService {

    getGamingHistory(historyType: GamingHistoryType, maxPageSize: number = 50): IHistoryPaginatorViewModel {
        switch (historyType) {
            case GamingHistoryType.SessionHistory:
                return new SessionGamingHistoryPaginatorModel(this.services, maxPageSize);
            default:
                return new UserGamingHistoryPaginatorModel(this.services, maxPageSize);
        }
    }
}

